import React from "react";
import styled, { css } from "styled-components";
import { Person } from "@domain/user/user";
import { fullName } from "@domain/user/utils";
import { getBanner } from "@utils/banner";
import { RoundedBlock } from "@ui/components/containers/roundedBlock";
import { row } from "@ui/components/layout";
import { ProfileBanner } from "./profileBanner";
import { ProfilePicture } from "./profilePicture";

interface PersonCardProps extends React.HTMLAttributes<HTMLDivElement> {
	person: Person;
}

export const PersonCard: React.FC<PersonCardProps> = ({ person, ...htmlProps }) => {
	const { avatar } = person;
	return (
		<Container {...htmlProps}>
			<ProfileBanner picture={undefined} big={true} defaultUrl={getBanner("id")} />
			<ProfilePictureWrapper>
				<Relative>
					{/* <Link to={Path.Profile(profile)}> */}
					<ProfilePicture
						// onClick={openModalProfilPicture}
						// alt={I18n.t("seo.profile.picture", { name: fullName(profile) })}
						picture={avatar}
						size="XL"
						shadowed
						// hideDetails={!hideDetails}
					/>
					{/* </Link> */}
				</Relative>
			</ProfilePictureWrapper>
			<Name smallMargin={true}>{fullName(person)}</Name>
		</Container>
	);
};

const Container = styled(RoundedBlock).withConfig({
	shouldForwardProp: (prop) => prop !== "hideDetails",
})<{ hideDetails?: boolean }>`
	position: relative;
	padding: 162px 33px 38px;

	${({ hideDetails }) =>
		hideDetails &&
		css`
			padding: 52px 31px 23px 31px;
		`};
`;

const ProfilePictureWrapper = styled.div`
	position: relative;
	${row(0, "space-between", "flex-end")};
`;

const Relative = styled.div`
	position: relative;
`;

const Name = styled.div.withConfig({
	shouldForwardProp: (prop) => prop !== "smallMargin",
})<{ smallMargin: boolean }>`
	${({ theme }) => theme.textStyles.primaryBold};
	margin-top: ${({ smallMargin }) => (smallMargin ? 15 : 35)}px;
	font-size: 1.25rem;
`;
